import { Card, CardActionArea, Grid } from "@mui/material";
import { setRefererInternal } from "modules/referer";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styled from "styled-components";
import theme from "theme";

type GameCardProps = {
  productId: string;
  thumbnailUrl: string;
  name: string;
  category: string;
  price: number;
  to: string;
  referer:
    | "store-top-page-list-new"
    | "store-top-page-list-extention"
    | "store-top-page-list-other";
};

const GameCard = ({
  productId,
  thumbnailUrl,
  category,
  price,
  name,
  to,
  referer,
}: GameCardProps) => {
  const [t] = useTranslation();

  const onClickCard = useCallback(() => {
    setRefererInternal({ productId, referer });
  }, [productId, referer]);

  return (
    <Grid alignItems="stretch" item md={3} sm={4} xs={6}>
      <Card sx={{ height: "100%" }}>
        <CardActionArea onClick={onClickCard} component={Link} to={to}>
          <Thumbnail src={thumbnailUrl} alt="" />
          <CardBody>
            <CategoryLabel>{category}</CategoryLabel>
            <Price>
              {price === 0 ? t("無料") : "¥" + price.toLocaleString("ja-JP")}
            </Price>
            <Name>{name}</Name>
          </CardBody>
        </CardActionArea>
      </Card>
    </Grid>
  );
};

const Thumbnail = styled.img`
  width: 100%;
  aspect-ratio: 16 / 9;
`;

const CardBody = styled.div`
  display: grid;
  grid-template-columns: min-content auto;
  grid-template-rows: auto auto;
  gap: 4px;
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
  font-family: sans-serif;
  background: #2a2a2a;
  ${theme.breakpoints.down("sm")} {
    display: flex;
    flex-direction: column;
  }
`;

const CategoryLabel = styled.span`
  width: max-content;
  padding: 2px 4px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  color: #fff;
  background-color: #000;
  ${theme.breakpoints.down("sm")} {
    order: 0;
  }
`;

const Name = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  grid-area: 2/ 1 / 3 /3;
  font-size: 16px;
  line-height: 1.4;
  ${theme.breakpoints.down("sm")} {
    order: 1;
    font-size: 14px;
  }
`;
const Price = styled.span`
  margin-top: auto;
  margin-left: auto;
  font-size: 14px;
  font-weight: bold;
  ${theme.breakpoints.down("sm")} {
    margin-left: 0;
    order: 2;
    font-size: 12px;
  }
`;

export default memo(GameCard);
